import { render, staticRenderFns } from "./ComponentPoint.vue?vue&type=template&id=75e75c01&scoped=true"
import script from "./ComponentPoint.vue?vue&type=script&lang=js"
export * from "./ComponentPoint.vue?vue&type=script&lang=js"
import style0 from "./ComponentPoint.vue?vue&type=style&index=0&id=75e75c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e75c01",
  null
  
)

export default component.exports